import { Swiper, Navigation, Pagination } from 'swiper/js/swiper.esm.js';

export default class LegTourismSlider {
  constructor(tourismSlider) {
    this.tourismSlider = tourismSlider;
    this.sliderContainer = tourismSlider.parentElement;
    this.prevButton = this.sliderContainer.querySelector('.swiper-button-prev');
    this.nextButton = this.sliderContainer.querySelector('.swiper-button-next');
    this.pagination = this.sliderContainer.querySelector('.swiper-pagination');
    this.mediaQuery = window.matchMedia('(max-width: 979px)');
    this.mySwiper = null;

    this.events();
  }

  events() {
    //this.mediaQuery.addListener(() => this.handleScreenChange(this.mediaQuery));
    //this.handleScreenChange(this.mediaQuery);

    this.mediaQuery.onchange = () => this.handleScreenChange(this.mediaQuery);

    this.handleScreenChange(this.mediaQuery);
  }

  handleScreenChange(e) {
    if (e.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    Swiper.use([Navigation, Pagination]);
    this.mySwiper = new Swiper(this.tourismSlider, {
      // Optional parameters

      speed: 1000,
      grabCursor: true,
      slidesPerView: 'auto',
      spaceBetween: 16,

      // Navigation arrows
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },

      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        //320: {
        //  slidesPerView: 2,
        //  spaceBetween: 20,
        //},
        //768: {
        //  slidesPerView: 3,
        //  spaceBetween: 40,
        //  grabCursor: false,
        //},
      },
    });
  }

  destroySwiper() {
    if (this.mySwiper) {
      this.mySwiper.destroy();
    }
  }
}
